import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";
import * as THREE from "three";

function VerticalLine({
  targetRef,
  upperLength = 50,
  lowerLength = 50,
  color = "red",
}) {
  const lineRef = useRef();

  useFrame(() => {
    if (targetRef.current && lineRef.current) {
      const pos = targetRef.current.position;
      const points = [
        new THREE.Vector3(pos.x, pos.y - lowerLength, pos.z),
        new THREE.Vector3(pos.x, pos.y + upperLength, pos.z),
      ];
      lineRef.current.geometry.setFromPoints(points);
    }
  });

  return (
    <line ref={lineRef}>
      <bufferGeometry />
      <lineBasicMaterial color={color} />
    </line>
  );
}

export default VerticalLine;
